import React from 'react';
import * as Panel2 from './panel';
import * as CGReact from './cg/cgreact';

const inputType = {
  type: 'dict' as const,
  objectType: {
    type: 'union' as const,
    members: [null, 'string' as const],
  },
};

type PanelStringCompareProps = Panel2.PanelProps<typeof inputType>;

const PanelStringCompare: React.FC<PanelStringCompareProps> = props => {
  const nodeValue = CGReact.useNodeValue(props.input.path);
  if (nodeValue.loading) {
    return <div>-</div>;
  }
  return (
    <div>
      {Object.entries(nodeValue.result).map(([key, value]) => (
        <div key={key}>
          {key}: {value == null ? 'null' : value}
        </div>
      ))}
    </div>
  );
};

export const Spec: Panel2.PanelSpec = {
  id: 'string-compare',
  Component: PanelStringCompare,
  inputType,
};
